import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient()
const rootEl = document.getElementById('root')

// Detect Squarespace editor mode
const isSquarespaceEditor = Boolean(window?.Squarespace?.Editor)

if (rootEl && !isSquarespaceEditor) {
  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>
  )
} else {
  console.log("⚠️ Booking form disabled inside Squarespace editor for safety.")
}